<template>
  <svg
    width="296"
    height="49"
    viewBox="0 0 296 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_877_64074)">
      <path
        d="M56.1156 32.3069C52.0959 32.3069 49.2458 28.868 49.7495 24.6258C50.2532 20.3835 53.9213 16.9447 57.941 16.9447C60.256 16.9447 62.1818 18.0857 63.3038 19.8623L70.65 12.0512C67.959 8.65531 63.8602 6.54102 59.0428 6.54102C49.6481 6.54102 41.0785 14.5776 39.9008 24.4926C38.723 34.4065 45.3841 42.4441 54.7777 42.4441C59.6154 42.4441 64.2322 40.311 67.7361 36.8889L61.227 30.3237C59.7888 31.5538 57.9917 32.3069 56.1156 32.3069Z"
        fill="url(#paint0_linear_877_64074)"
      />
      <path
        d="M93.8723 0H107.074L82.5174 40.87H69.3169L93.8723 0Z"
        fill="url(#paint1_linear_877_64074)"
      />
      <path
        d="M38.6487 26.8899C38.6436 26.0593 38.6902 25.2161 38.7916 24.3635C38.9223 23.2602 39.1402 22.1726 39.4413 21.1081L37.9686 9.80566L29.5631 23.7992L30.2402 28.9664H26.4414L22.0942 36.2207H31.1828L31.7869 40.8709L42.0147 40.8698L41.4704 36.701C39.6014 33.882 38.6294 30.5029 38.6487 26.8899Z"
        fill="url(#paint2_linear_877_64074)"
      />
      <path
        d="M24.5554 8.12891H37.757L13.2016 49H0L24.5554 8.12891Z"
        fill="url(#paint3_linear_877_64074)"
      />
      <path
        d="M75.2148 8.12891H67.7064C69.324 9.1032 70.7775 10.4467 72.1255 12.0502L66.2894 18.2431L69.0412 39.3556L77.4456 25.3694L75.2148 8.12891Z"
        fill="url(#paint4_linear_877_64074)"
      />
    </g>
    <path
      d="M102.403 28.4046H98L98.6205 25.6504H110.633L110.038 28.4046H105.635L103.005 40.3497H99.7764L102.403 28.4046Z"
      fill="black"
    />
    <path
      d="M116.416 35.084H113.909L112.76 40.3526H109.553L112.804 25.6533H119.242C121.679 25.6533 123.9 27.2394 123.913 29.7969C123.925 32.465 122.083 34.4692 119.645 34.9088L121.749 40.3526H118.202L116.416 35.084ZM120.549 30.1012C120.542 29.0653 119.661 28.3368 118.621 28.3368H115.415L114.53 32.3913H117.872C119.566 32.3943 120.555 31.423 120.549 30.1012Z"
      fill="black"
    />
    <path
      d="M135.058 37.8166H128.328L126.825 40.3526H123.143L132.221 25.6533H136.24L138.794 40.3526H135.452L135.058 37.8166ZM129.805 35.1055H134.797L133.77 28.3399L129.805 35.1055Z"
      fill="black"
    />
    <path
      d="M145.928 29.926L143.629 40.3526H140.422L143.673 25.6533H146.971L151.717 35.7264L153.95 25.6533H157.157L153.906 40.3526H150.813L145.928 29.926Z"
      fill="black"
    />
    <path
      d="M158.534 35.6132C159.601 36.981 161.57 37.8848 163.649 37.8848C165.252 37.8848 165.904 36.981 165.897 36.188C165.894 35.3058 164.738 34.8447 163.315 34.3375C161.211 33.609 158.587 32.6407 158.575 30.0187C158.565 27.7932 160.697 25.4355 164.423 25.4355C166.817 25.4355 169.079 26.2962 170.42 27.8147L168.442 29.9972C167.375 28.74 165.52 28.1252 164.03 28.1252C162.789 28.1252 161.932 28.8537 161.935 29.6683C161.938 30.4613 163.094 30.904 164.518 31.4112C166.622 32.1612 169.293 33.151 169.302 35.7084C169.315 38.3089 167.135 40.6236 163.409 40.6236C160.452 40.6236 157.847 39.4985 156.578 37.8909L158.534 35.6132Z"
      fill="black"
    />
    <path
      d="M173.91 25.6504H180.414C183.306 25.6504 185.007 27.5009 185.019 29.7264C185.029 31.9088 183.533 35.1487 178.811 35.1487H175.016L173.866 40.3497H170.66L173.91 25.6504ZM181.655 30.0368C181.652 29.0655 180.903 28.34 179.75 28.34H176.521L175.636 32.3945H178.956C180.673 32.3945 181.662 31.3586 181.655 30.0368Z"
      fill="black"
    />
    <path
      d="M194.619 25.4072C198.774 25.4072 202.015 27.9647 202.034 31.9761C202.056 36.7806 198.304 40.6168 193.334 40.6168C189.158 40.6168 185.914 38.0593 185.895 34.0264C185.876 29.2188 189.649 25.4072 194.619 25.4072ZM194.43 28.1829C191.517 28.1829 189.224 30.6728 189.24 33.8266C189.252 36.3164 191.089 37.838 193.504 37.838C196.396 37.838 198.711 35.3481 198.695 32.1943C198.682 29.726 196.846 28.1829 194.43 28.1829Z"
      fill="black"
    />
    <path
      d="M209.23 35.084H206.723L205.574 40.3526H202.367L205.618 25.6533H212.056C214.493 25.6533 216.714 27.2394 216.726 29.7969C216.739 32.465 214.896 34.4692 212.459 34.9088L214.563 40.3526H211.016L209.23 35.084ZM213.363 30.1012C213.356 29.0653 212.474 28.3368 211.435 28.3368H208.229L207.344 32.3913H210.685C212.38 32.3943 213.369 31.423 213.363 30.1012Z"
      fill="black"
    />
    <path
      d="M222.657 28.4046H218.254L218.875 25.6504H230.888L230.292 28.4046H225.889L223.259 40.3497H220.031L222.657 28.4046Z"
      fill="black"
    />
    <path
      d="M238.509 37.8166H231.778L230.276 40.3526H226.594L235.671 25.6533H239.69L242.244 40.3526H238.903L238.509 37.8166ZM233.258 35.1055H238.251L237.224 28.3399L233.258 35.1055Z"
      fill="black"
    />
    <path
      d="M248.131 28.4046H243.728L244.348 25.6504H256.361L255.766 28.4046H251.359L248.729 40.3497H245.501L248.131 28.4046Z"
      fill="black"
    />
    <path
      d="M258.643 25.6504H261.849L258.599 40.3497H255.392L258.643 25.6504Z"
      fill="black"
    />
    <path
      d="M271.106 25.4072C275.26 25.4072 278.501 27.9647 278.524 31.9761C278.546 36.7806 274.794 40.6168 269.824 40.6168C265.648 40.6168 262.404 38.0593 262.385 34.0264C262.363 29.2188 266.139 25.4072 271.106 25.4072ZM270.917 28.1829C268.004 28.1829 265.711 30.6728 265.726 33.8266C265.739 36.3164 267.575 37.838 269.991 37.838C272.882 37.838 275.197 35.3481 275.182 32.1943C275.169 29.726 273.333 28.1829 270.917 28.1829Z"
      fill="black"
    />
    <path
      d="M284.586 29.926L282.287 40.3526H279.081L282.331 25.6533H285.629L290.375 35.7264L292.608 25.6533H295.815L292.564 40.3526H289.471L284.586 29.926Z"
      fill="black"
    />
    <defs>
      <linearGradient
        id="paint0_linear_877_64074"
        x1="58.9215"
        y1="41.962"
        x2="52.6224"
        y2="7.43705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_877_64074"
        x1="88.1952"
        y1="40.8704"
        x2="88.1952"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_877_64074"
        x1="30.5379"
        y1="41.2645"
        x2="46.3427"
        y2="14.8086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_877_64074"
        x1="18.8786"
        y1="48.9996"
        x2="18.8786"
        y2="8.12922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_877_64074"
        x1="62.2319"
        y1="35.2884"
        x2="77.6041"
        y2="9.55675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <clipPath id="clip0_877_64074">
        <rect width="107.074" height="49" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
